<template>
    <el-dialog :custom-class="'user-dialog'" :visible="dialogvisible" width="60%"
               @close="$emit('update:dialogvisible', false); visiblePassword=false">
        <el-tabs v-model="activeName" class="urunBaglanti">
        </el-tabs>
        <el-upload
                style="position: relative; margin-top: 20px"
                class="resimler margin-20"
                action=""
                list-type="picture-card"
                multiple
                :file-list="imageListMain"
                :auto-upload="false"
                accept=".jpg,.jpeg,.png"
                :on-change="imageUpload"
                :on-preview="firstImage"
                :on-remove="imageRemove">
            <i slot="default" class="el-icon-plus"></i>
        </el-upload>
        <el-button class="margin-20" style="margin-top: 15px;width: 150px;" type="primary"
                   v-on:click="serverImageList"
                   @click="dialogImgServerVisible = true; " size="mini">
            Sunucudan
            Seç
        </el-button>
        <el-button class="margin-20" style="margin-top: 15px;width: 150px;" type="success"
                   @click="guncelle" size="mini">
            Kaydet
        </el-button>
        <el-dialog
                append-to-body
                title='Sunucudan Fotoğraf Seç'
                :visible.sync="dialogImgServerVisible"
                width="60%"
                center>
            <el-upload
                    action="#"
                    accept=".jpg,.jpeg,.png"
                    :on-change="serverImageUpload"
                    list-type="picture-card"
                    :file-list="imageListServer"
                    :auto-upload="false">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                </div>
            </el-upload>
        </el-dialog>
    </el-dialog>

</template>
<script>
    import urunService from '../WSProvider/UrunService'
    import controllerService from '../WSProvider/ControllerService'
    import notification from '../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataOnurBoya = "";
    export default {
        name: 'UrunFotograf',
        props: ['urundata', 'dialogvisible'],
        data() {
            return {
                selection: '',
                orjinalResimList: [],
                updateData: [],
                anaResim: {},
                secilenKategori: [],
                imageListMain: [],
                imageListServer: [],
                activeName: '1',
                urun: this.urundata,
                imageUrl: urunService.imageUrlOrta,
                visiblePassword: false,
                dialogImgServerVisible: false,
                root: false,
                yetkili: false,
            }

        },
        mounted() {
            this.orjinalResimList = this.urun.resim;
            if (this.orjinalResimList.length > 0) {
                this.anaResim = this.orjinalResimList[0];
            }
            let self = this;
            this.urun['resim'].forEach(function (e) {
                if (e) {
                    self.imageListMain.push({
                        name: e,
                        url: urunService.imageUrlOrta + e
                    });
                }
            });
        },
        methods: {
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim('urun').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: urunService.imageUrlOrta + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            imageUploadtoServer(file) {
                let obj = this.imageListMain.find(data => data.name === file.name);
                if (obj === undefined) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    notification.Status('success', this, file.name + ' resmi eklendi.');
                } else {
                    notification.Status('warning', this, 'Bu resim zaten mevcut');
                }

            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, "urun-" + randomText(7) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.urun.baslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "urun-" + randomText(7) + '-' + linkTemizle(this.urun.baslik) + ".jpg";
                        } else {
                            imgname = "urun-" + randomText(7) + '-' + linkTemizle(this.urun.baslik) + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "urun-" + randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "urun-" + randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                    if (obj === undefined) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.sumResimFonk(file, imgname, item);
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            sumResimFonk(file, imgname, item) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('urun', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.imageListMain.push(item);
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            guncelle() {
                let self = this;
                if (self.imageListMain.length === 0) {
                    if (self.orjinalResimList.length > 0) {
                        self.orjinalResimList.forEach(function (e) {
                            updateListImage(self, 'resim', 0, e);
                        })
                    }
                } else {
                    for (var i = 0; i < self.imageListMain.length; i++) {
                        if (i === 0) {
                            if (self.imageListMain[0].name !== self.orjinalResimList[0]) {
                                updateListImage(self, 'resim', 2, self.imageListMain[0].name);
                                let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[0]);
                                if (obj !== undefined) {
                                    updateListImage(self, 'resim', 1, self.orjinalResimList[0]);
                                }
                            }
                        } else {
                            let obj = self.orjinalResimList.find(data => data === self.imageListMain[i].name);
                            if (obj === undefined) {
                                updateListImage(self, 'resim', 1, self.imageListMain[i].name);
                            }
                        }
                    }
                    if (self.orjinalResimList.length > 0) {
                        for (var y = 1; y < self.orjinalResimList.length; y++) {
                            let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[y]);
                            if (obj === undefined) {
                                updateListImage(self, 'resim', 0, self.orjinalResimList[y]);
                            }
                        }
                    }
                }
                // console.log(this.updateData);
                urunService.urunGuncelle(this.urun.urunId,this.updateData).then((response) => {
                    if(response.status === 200){
                        this.updateData = [];
                        notification.Status('success', this, 'Ürün başarıyla güncellendi.');
                    }else notification.Status(response.status,this)
                })
            }
        }
    }
    function updateListImage(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables';

    dl i {
        color: #0075c3;
        margin: 0 10px;
    }

    dl.horizontal dt {
        text-align: left;
        width: 36%;
    }

    .el-dialog.user-dialog {
        /*max-width: 500px !important;*/
    }

    .form-box .el-form div {
        margin: 20px 0;
    }

    .form-box .el-form i {
        font-size: 20px;
    }

    .el-dialog.user-dialog {
        /*max-width: 400px;*/

        .el-dialog__header {
            padding: 0;

            .el-dialog__headerbtn {
                z-index: 1;
                background: rgba(0, 0, 0, 0.05);
                min-width: 18px;
                min-height: 18px;
                border-radius: 4px;

                .el-dialog__close {
                    color: $background-color;
                }
            }
        }

        .el-dialog__body {
            padding: 0;
        }

        .avatar-box {
            height: 70px;
            background: $text-color-accent;
            margin-bottom: 20px;
            position: relative;

            img {
                width: 100px;
                height: 100px;
                border-radius: 50%;
                position: relative;
                bottom: -50px;
                display: block;
                margin: 0 auto;
                background: white;
                border: 2px solid $text-color-accent;
                box-sizing: border-box;
            }

        }

        .form-box {
            padding: 20px;
            box-sizing: border-box;

            & > * {
                margin: 10px 0;
            }
        }
    }
</style>
